import { Stack } from 'ui/baseComponents'
import {
  PASSWORD_REQUIREMENTS,
  PASSWORD_REQUIREMENTS_HEADING,
} from 'ui/screens/SignIn/consts'
import { colors } from 'theme/colors'
import { STRIVEPD_FONT_FAMILY } from 'theme/strivePDTheme'

const STYLES = {
  container: {
    color: colors.GREY[700],
    fontFamily: STRIVEPD_FONT_FAMILY,
    fontSize: '0.875rem',
    fontStyle: 'italic',
    marginTop: '0.5rem',
    width: '100%',
  },
  list: {
    listStylePosition: 'outside',
    margin: '0.25rem 0 0',
    paddingLeft: '1.25rem',
  },
}

const PasswordRequirements = () => (
  <Stack data-cy="password-requirements" sx={STYLES.container}>
    {PASSWORD_REQUIREMENTS_HEADING}
    <ul style={STYLES.list}>
      {PASSWORD_REQUIREMENTS.map((requirement) => (
        <li key={requirement}>{requirement}</li>
      ))}
    </ul>
  </Stack>
)

export default PasswordRequirements
